import { Link } from 'react-router-dom'
import { LandingNav } from '@/components/landing'

export function CheckoutCancelPage() {
  return (
    <div className="min-h-screen bg-primary-bg">
      <LandingNav />
      <div className="max-w-lg mx-auto px-4 py-24 text-center">
        <h1 className="text-3xl font-medium mb-4">Checkout canceled</h1>
        <p className="text-secondary-text mb-8">
          No worries — nothing was charged. You can pick a plan whenever you're
          ready.
        </p>
        <Link to="/pricing" className="btn btn-secondary">
          Back to pricing
        </Link>
      </div>
    </div>
  )
}
